import React from 'react';
import { FormattedMessage } from 'react-intl';

import * as styles from './styles/styles.module.scss';
import Link from 'components/Link';

function MiniFooter() {
  return (
    <div className={styles.container}>
      <div className={styles.text}>
        <div className={styles.rightsReserved}>
          <FormattedMessage
            defaultMessage="{year} AllTrails, LLC All Rights Reserved"
            values={{
              year: new Date().getFullYear()
            }}
          />
        </div>
        <div className={styles.links}>
          <Link href="/privacy">
            <FormattedMessage defaultMessage="Privacy Policy" />
          </Link>
          |
          <Link href="/terms">
            <FormattedMessage defaultMessage="Terms of Service" />
          </Link>
        </div>
      </div>
    </div>
  );
}

export default MiniFooter;
